import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
// import TabsClientNew from "../Components/new-client-dashboard/NewTabs";
import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import MoreChangesTab from "../Components/new-client-dashboard/MoreChangesTab";
import DogBiteTab from "../Components/DogBite/tabs/dog-bite";
import DocumentRow from "../Components/DocumentRow/DocumentRow";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

const PAGE_TITLES = {
  dogbite: "Dog Bite",
  "animal-atk-notes": "Animal Attack Notes",
  "attack-timeline": "Attack Timeline",
  photo: "Photos",
};

const PHOTO_ICON_URL =
  "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg";

const PageTitle = ({ currentPage }) => (
  <div
    style={{
      width: "100%",
      justifyContent: "flex-start",
      background: "var(--primary)",
      height: "25px",
      marginBottom: "5px",
    }}
  >
    <span
      className="fw-bold text-white"
      style={{
        height: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {PAGE_TITLES[currentPage]}
    </span>
  </div>
);

const PageContent = ({ currentPage }) => {
  switch (currentPage) {
    case "dogbite":
      return <DogBiteTab />;
    case "photo":
      return <PhotoTab pageId={23} pageName={""} />;
    default:
      return null;
  }
};

const DogBitePage = () => {
  const [currentPage, setCurrentPage] = useState("dogbite");
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 23).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 23, dispatch);
  }, [dispatch]);

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const mainTabs = useMemo(
    () => [
      {
        id: "dogbite",
        label: "Dog Bite",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("dogbite"),
        leftHand: false,
      },
      {
        id: "animal-atk-notes",
        label: "Animal Attack Notes",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("animal-atk-notes"),
        leftHand: false,
      },
      {
        id: "attack-timeline",
        label: "Attack Timeline",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("attack-timeline"),
        leftHand: false,
      },
    ],
    [handlePageChange]
  );

  const photoTabs = useMemo(
    () => [
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span className="fw-bold text-gold p-r-5">
            <img
              src={PHOTO_ICON_URL}
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Summary"
              className="d-flex align-items-center justify-content-center"
            />
          </span>
        ),
      },
    ],
    []
  );

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="23" />
          <ActionBarComponent
            src="https://simplefirm-bucket.s3.amazonaws.com/static/images/animal-bite-icon.svg"
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <div className="d-flex align-items-center">
              <div style={{ width: "85%" }}>
                <NewChangesTabs
                  currentTab={currentPage}
                  tabsData={mainTabs}
                  height={25}
                  labelClass=" justify-content-start"
                />
              </div>

              <div style={{ width: "15%", position: "relative", right: "208px" }}>
                <MoreChangesTab
                  currentTab={currentPage}
                  tabsData={photoTabs}
                  height={25}
                  labelClass="p-l-5 p-r-5 justify-content-end"
                />
              </div>
            </div>

            <PageTitle currentPage={currentPage} />
            <PageContent currentPage={currentPage} />
            <div className="documents-wrapper m-t-5" style={{ marginRight: "0px" }}>
              <div className="col-12 pe-0">
                <DocumentRow pageName="Dog Bite" clientProvider={""} page_id={23} />
              </div>
            </div>

            <NotesSectionDashboard pageName={"DogBite"} />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DogBitePage;
